import { TableUtility }                                from 'ClientService';
import { useEffect, useMemo, useState }                from 'react';
import { useDispatch, useSelector }                    from 'react-redux';
import { findTableColumnsConfigForUserRequest }        from 'Redux/Action';
import { getTableColumnsConfig, isTableConfigLoading } from 'Redux/Query';

export const useTable = ({
  selectRows = false,
  expandRows = false,
  dataSourceQuery = () => {},
  totalQuery = () => {},
  loadingQuery = () => {},
  columnsConfig = null,
  customProps = {},
}) => {

  const dispatch = useDispatch();

  const [ selectedRows, setSelectedRows ] = useState([]);
  const [ expandedRows, setExpandedRows ] = useState([]);

  const _columnsConfig = useSelector(getTableColumnsConfig(columnsConfig));
  const isConfigLoading = useSelector(isTableConfigLoading);
  const total = useSelector(totalQuery);
  const isLoading = useSelector(loadingQuery);

  const mergedConfig = useMemo(() => {
    return (_columnsConfig ?? []).map((column) => {
      const config = Object.assign(
        {
          key: column.key,
          searchable: TableUtility.getHelper(column.searchable),
          sortable: TableUtility.getHelper(column.sortable),
          title: column.title,
          ...column.config,
        },
        column.type ? { type: column.type } : {},
        column.tooltip ? { tooltip: TableUtility.getHelpText(column.tooltip) } : {},
        column.customRenderKey ? { render: (value, record) => TableUtility.getCustomRenderer({
            key: column.customRenderKey,
            value,
            record,
          }) } : {},

      );
      if(config?.filters && typeof config.filters === 'string' && config.filters.startsWith('Filter.')) {
        config.filters = TableUtility.getCustomFilters(config.filters, customProps)
      }
      if(config?.csv && `${(config?.csv?.type || '').toLowerCase()}` === 'custom' && typeof config?.csv?.parser === 'string' && (config?.csv?.parser || '').startsWith('Parser.')) {
        config.csv.parser = TableUtility.getCustomColumnCsvParser(config?.csv?.parser)
      }
      if(config?.searchBar && typeof config.searchBar === 'string' && config.searchBar.startsWith('SearchBar.')) {
        const SearchBar = TableUtility.getCustomSearchBar(config.searchBar);
        if(!!SearchBar) {
          config.searchBar = (props) => SearchBar(props);
        }
      }

      return config;
    });
  }, [_columnsConfig]);


  useEffect(() => {
    if(!columnsConfig) {
      return;
    }
    dispatch(findTableColumnsConfigForUserRequest(columnsConfig));
  }, [])

  const dataSource = useSelector(dataSourceQuery);

  const handleSelectRow = (selectedRows) => {
    setSelectedRows(selectedRows);
  };

  const handleExpandRow = (expandedRows) => {
    setExpandedRows(expandedRows);
  };

  return {
    total,
    dataSource,
    selectedRows,
    expandedRows,
    handleSelectRow: selectRows ? handleSelectRow : null,
    handleExpandRow: expandRows ? handleExpandRow : null,
    isLoading: isLoading || isConfigLoading,
    columns: mergedConfig,
  };

}
